<ion-button [color]="color"
            [buttonType]="buttonType"
            [disabled]="disabled"
            [expand]="expand"
            [fill]="fill"
            [shape]="shape"
            [size]="size"
            [strong]="strong"
            [type]="type"
>
  <ion-icon *ngIf="icon && !isLoading" slot="{{iconposition}}" name="{{icon}}"></ion-icon>
  <ion-spinner *ngIf="isLoading" [color]="spinnerColor"></ion-spinner>
  <ng-container *ngIf="!isLoading">
    <ng-content></ng-content>
  </ng-container>
</ion-button>
